__turbopack_context__.v({
  "buttons": "DTPaymentOnHoldModal-module__uY4krG__buttons",
  "cardIcon": "DTPaymentOnHoldModal-module__uY4krG__cardIcon",
  "main": "DTPaymentOnHoldModal-module__uY4krG__main",
  "title": "DTPaymentOnHoldModal-module__uY4krG__title",
});
